//dựa theo enum TestReceiving trong Backend. Enum nầy cũng tương ứng config "Quy trình xác nhận lấy mẫu"
export const testReceiving = {
  Lab: 'Lis',
  HIS: 'HIS',
}